/* ARTSY FARTSY - kundens eget design som miniature i kurven.
 *
 * Kurven viser `line_item.image`, altsaa produktbilledet. Paa en personlig
 * plakat er det et andet motiv end det kunden lige har lavet, og det er en
 * daarlig sidste fornemmelse foer betaling.
 *
 * Adressen paa billedet staar i ordrelinjens skjulte felt `_preview`.
 * Understregen betyder at Liquid IKKE skriver det ud - men /cart.js har det
 * med, og derfra kan vi hente det. Derfor ligger det her i stedet for i
 * temaets egne filer: det virker i kurven, i kvitteringsboksen og alle andre
 * steder temaet tegner en linje, uden at nogen skal rette i
 * `main-cart.liquid`.
 *
 * To steder, to maader at finde linjen paa:
 *
 *  - Kurven tegner hver linje med `data-key`, og den noegle staar ogsaa i
 *    /cart.js. Det er en praecis sammenkobling.
 *  - Kvitteringsboksen efter "Add to bag" (.purchase-confirmation-popup)
 *    bygges af temaets javascript og har ingen noegle. Der bruges den SIDSTE
 *    linje i kurven i stedet: Shopify laegger en ny linje bagest, og hvert
 *    design faar sin egen linje, fordi `_design_id` er forskelligt. Laegger
 *    kunden det SAMME design i kurven to gange, taeller Shopify den gamle
 *    linje op i stedet for at tilfoeje en - og saa kan boksen naa at vise en
 *    anden plakat. Det er den ene kant den her genvej har. */
(function () {
  var kortet = {}; // item.key -> billedadresse (null = linjen har ingen)
  var sidste = null; // adressen paa den nyeste linje, hvis den har en
  var henter = false;
  var sidstHentet = 0;

  function adresse(v) {
    return typeof v === "string" && /^https?:\/\//.test(v) ? v : null;
  }

  function saet(img, url) {
    if (!img || img.getAttribute("data-ac-preview") === url) return;
    img.setAttribute("data-ac-preview", url);
    // srcset vinder over src. Bliver den staaende, tegner browseren
    // produktbilledet videre, og vores src bliver aldrig brugt.
    img.removeAttribute("srcset");
    img.removeAttribute("sizes");
    img.src = url;
    img.style.objectFit = "contain";
  }

  function linjer() {
    return document.querySelectorAll("[data-key]");
  }

  /* Saetter billederne fra det vi allerede ved. Returnerer true, hvis der
   * stod en linje vi ikke havde en adresse til - saa er kurven aendret, og
   * kortet skal hentes igen. */
  function anvend() {
    var mangler = false;

    linjer().forEach(function (linje) {
      var key = linje.getAttribute("data-key");
      if (!key) return;

      var url = kortet[key];
      if (url === undefined) { mangler = true; return; }
      if (url === null) return; // linjen har ingen preview - fx en ramme

      linje.querySelectorAll("img").forEach(function (img) { saet(img, url); });
    });

    return mangler;
  }

  /* Kvitteringsboksen. Den vises FOER kurven er tegnet om, saa kortet skal
   * hentes forfra hver gang den dukker op med et billede vi ikke har rettet. */
  function anvendPopup() {
    var boks = document.querySelector(".purchase-confirmation-popup");
    if (!boks) return false;

    var img = boks.querySelector("img");
    if (!img || img.getAttribute("data-ac-preview")) return false;

    var noegle = boks.querySelector("[data-key]");
    var url = noegle ? kortet[noegle.getAttribute("data-key")] : sidste;

    if (url === undefined) return true; // vi ved det ikke endnu - hent
    if (url) saet(img, url);
    return false;
  }

  function hent(tving) {
    if (henter) return;
    if (!tving && Date.now() - sidstHentet < 800) return;
    henter = true;

    fetch("/cart.js", { headers: { Accept: "application/json" }, credentials: "same-origin" })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart || !cart.items) return;
        sidste = null;
        cart.items.forEach(function (i) {
          var u = adresse(i.properties && i.properties._preview);
          kortet[i.key] = u;
          if (u) sidste = u; // den bagerste linje med et design vinder
        });
        anvend();
        anvendPopup();
      })
      .catch(function () { /* kurven kan svare 404 i temaeditoren */ })
      .then(function () { henter = false; sidstHentet = Date.now(); });
  }

  function tjek() {
    var popupMangler = anvendPopup();
    if (popupMangler) return hent(true); // boksen kom lige - kurven er ny
    if (!linjer().length) return;
    if (anvend()) hent();
  }

  document.addEventListener("DOMContentLoaded", tjek);
  if (document.readyState !== "loading") tjek();

  /* Temaet tegner linjerne om ved maengdeaendring, naar skuffen aabner og
   * naar kvitteringsboksen fyldes. Observatoeren er billig: `tjek` goer
   * ingenting, naar der hverken staar linjer eller en boks. */
  var vent = null;
  new MutationObserver(function () {
    clearTimeout(vent);
    vent = setTimeout(tjek, 120);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
